<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">업무전달</span>
            <span class="txt">직원 간 업무를 전달 할 수 있도록 글을 작성할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link :to="`/madmin/board/list`" class="com-btn">목록</router-link>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: 560px" />
                    <col style="width: 150px" />
                    <col style="width: 560px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>제목</th>
                        <td>{{ workList.title }}</td>
                        <th>글쓴이</th>
                        <td>{{ writerName }}</td>
                    </tr>
                    <tr>
                        <th>참석팀</th>
                        <td>{{ workList.joinTeamName }}</td>
                        <th>조회수</th>
                        <td>{{ workList.viewCount }}</td>
                    </tr>
                    <tr>
                        <th>상태</th>
                        <td>
                            <select-form
                                :disabled="centerStaffId != workList.centerStaffId"
                                :select-data="['진행중', '처리완료']"
                                :select-value="['O', 'C']"
                                :selected-value="writeState"
                                class="w160"
                                @update:set="(val) => (writeState = val)"
                            ></select-form>
                            <button
                                :disabled="centerStaffId != workList.centerStaffId"
                                class="com-btn light-blue"
                                @click="changeState"
                            >
                                변경
                            </button>
                        </td>
                        <th>등록일</th>
                        <td>{{ workList.noticeStartDate }}</td>
                    </tr>
                    <tr>
                        <th>참석팀</th>
                        <td colspan="3">
                            <div
                                v-for="(staff, index) in workStaffList"
                                :key="index"
                                :class="{ disabled: !isStaffStatusEditable(staff) }"
                                class="info-txt-check"
                            >
                                <span class="txt">{{ staff.center_staff_nm }}</span>
                                <div class="check-line flex">
                                    <div class="com-radio">
                                        <input
                                            :id="`user-radio-${index}-1`"
                                            v-model="staffChcek[index]"
                                            :disabled="!isStaffStatusEditable(staff) || isStaffStatusUpdating"
                                            :name="`user-radio-${index}`"
                                            type="radio"
                                            value="O"
                                            @change="attndChange(index)"
                                        />
                                        <label :for="`user-radio-${index}-1`">진행중</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            :id="`user-radio-${index}-2`"
                                            v-model="staffChcek[index]"
                                            :disabled="!isStaffStatusEditable(staff) || isStaffStatusUpdating"
                                            :name="`user-radio-${index}`"
                                            type="radio"
                                            value="C"
                                            @change="attndChange(index)"
                                        />
                                        <label :for="`user-radio-${index}-2`">완료</label>
                                    </div>
                                </div>
                            </div>
                            <!--
                        <div class="info-txt-check">
                            <span class="txt">최성연</span>
                            <div class="check-line">
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-1" id="user-radio-1-1" checked>
                                    <label for="user-radio-1-1">진행중</label>
                                </div>
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-1" id="user-radio-1-2">
                                    <label for="user-radio-1-2">완료</label>
                                </div>
                            </div>
                        </div>
                        <div class="info-txt-check disabled">
                            <span class="txt">이지수</span>
                            <div class="check-line">
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-2" id="user-radio-2-1" disabled checked>
                                    <label for="user-radio-2-1">진행중</label>
                                </div>
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-2" id="user-radio-2-2" disabled>
                                    <label for="user-radio-2-2">완료</label>
                                </div>
                            </div>
                        </div>
                        --></td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="workList.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="replay-area">
                <div class="write-box">
                    <span class="tit">댓글</span>
                    <div class="input-line">
                        <input v-model="replyText" placeholder="댓글을 입력하세요" type="text" />
                        <button class="com-btn" @click="updateReply">등록</button>
                    </div>
                </div>
                <div class="list-box">
                    <ul class="list">
                        <li v-for="(item, index) in this.workList.centerTaskStaffComments" :key="index">
                            <span class="name">{{ item.center_staff_nm }}</span>
                            <p v-if="!commentEdit || index != commentId" class="txt">{{ item.comment }}</p>
                            <div v-if="commentEdit && index == commentId">
                                <input v-model="item.comment" type="text" />
                                <button
                                    v-if="commentEdit"
                                    class="com-btn"
                                    @click="replyAction('update', item.center_task_staff_comment_id, item.comment)"
                                >
                                    댓글 수정
                                </button>
                            </div>
                            <span class="day">{{ item.upd_dt | timestampFilter }}</span>
                            <button
                                v-if="centerStaffId == item.center_staff_id"
                                class="modify"
                                @click="editComment(index)"
                            >
                                <span class="blind">수정하기</span>
                            </button>
                            <button
                                v-if="centerStaffId == item.center_staff_id"
                                class="del"
                                @click="replyAction('delete', item.center_task_staff_comment_id, item.comment)"
                            >
                                <span class="blind">삭제하기</span>
                            </button>
                        </li>
                        <!--
                        <li>
                            <span class="name">김하연</span>
                            <p class="txt">스터디는 아무나 참석 할 수 있는 것인가요? 인원수 제한은 몇명이에요?</p>
                            <span class="day">2019.08.22</span>
                            <button class="modify"><span class="blind">수정하기</span></button>
                            <button class="del"><span class="blind">삭제하기</span></button>
                        </li>
                        -->
                    </ul>
                </div>
            </div>

            <div class="com-btn-area">
                <div class="right-box">
                    <router-link :to="`/madmin/board/list`" class="com-btn">목록</router-link>
                    <router-link :to="`/madmin/board/edit`" class="com-btn blue">글 등록</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';

export default {
    name: 'BoardDetail',
    props: {},
    computed: {},
    data() {
        return {
            commentEdit: false,
            centerId: this.$route.params.centerId,
            centerTaskId: this.$route.params.centerTaskId,
            centerStaffId: this.$store.state.auth.user.uid,
            isLoading: false,
            workList: {},
            workStaffList: [],
            staffChcek: [],
            isStaffStatusUpdating: false,
            pendingStaffStatusIndexes: [],
            writerName: '',
            replyText: '',
            writeState: '',
            commentId: '',
        };
    },
    mounted() {
        this.onSearchList();
    },
    methods: {
        async onSearchList() {
            try {
                this.isLoading = true;
                // this.isStopPopup = isStopPopup;
                const { data } = await this.getWorkList();
                this.workList = data;
                this.workStaffList = data.centerTaskStaffs;
                this.workStaffList.forEach((element, index) => {
                    this.staffChcek[index] = element.staff_status_cd;
                    if (this.workList.centerStaffId == element.center_staff_id) {
                        this.writerName = element.center_staff_nm;
                    }
                });
                this.writeState = data.status;
                this.isLoading = false;

                console.log('===> Success Loading : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getWorkList() {
            return api.get(`/admin/api/centerTask/detail/${this.centerId}/${this.centerTaskId}`);
        },
        async changeState(val) {
            // console.log( val );
            try {
                const { data } = await this.onChangeStat();
                alert('게시글 상태가 변경되었습니다.');
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },

        onChangeStat() {
            return api.put(`/admin/api/centerTask/updateStatus`, {
                centerId: this.centerId,
                centerTaskId: this.centerTaskId,
                status: this.writeState,
            });
        },
        async updateReply() {
            if (this.replyText.length < 1) {
                return;
            }

            try {
                const replyData = {
                    centerId: this.centerId,
                    centerTaskId: this.centerTaskId,
                    centerStaffId: this.centerStaffId,
                    comment: this.replyText,
                };

                const data = await this.sendPostReply(replyData);
                console.log(data);
                alert('등록 되었습니다.');
                this.replyText = '';
                this.onSearchList(); // 리프레쉬
            } catch (error) {
                alert('등록 실패했습니다.');
                console.log(error);
            }
        },

        sendPostReply(data) {
            return api.post('/admin/api/centerTask/createComment', {
                ...data,
            });
        },

        // 참석자 상태 변경 API
        attendStatus(index, staffStatus) {
            // 변경한 참석자만 전송한다. 전체를 보내면 다른 참석자가 그사이 바꾼 상태를 화면의 옛 값으로 되돌리게 된다.
            const datas = [
                {
                    centerStaffId: this.workStaffList[index].center_staff_id,
                    staffStatus,
                },
            ];
            return api.put(`/admin/api/centerTask/updateStaffStatus/${this.centerId}/${this.centerTaskId}`, {
                datas,
            });
        },
        // 참석자 라디오 조작 권한. 본인 항목이거나 글쓴이면 바꿀 수 있다.
        isStaffStatusEditable(staff) {
            return (
                this.centerStaffId == staff.center_staff_id || this.centerStaffId == this.workList.centerStaffId
            );
        },
        // 상태변경시 확인
        async attndChange(index) {
            // 라디오는 v-model 로 이미 바뀐 뒤 이 핸들러가 호출된다. 요청을 버리면 화면만 앞서가므로,
            // 겹친 변경은 버리지 않고 큐에 쌓아 순서대로 보낸다. 동시에 보내면 먼저 보낸 응답이
            // 나중에 도착해 게시글 상태를 서버 최종 상태와 다르게 덮을 수 있다.
            if (!this.pendingStaffStatusIndexes.includes(index)) {
                this.pendingStaffStatusIndexes.push(index);
            }
            if (this.isStaffStatusUpdating) {
                return;
            }
            this.isStaffStatusUpdating = true;

            try {
                let hasFailure = false;
                while (this.pendingStaffStatusIndexes.length > 0) {
                    const succeeded = await this.sendStaffStatus(this.pendingStaffStatusIndexes.shift());
                    hasFailure = hasFailure || !succeeded;
                }
                // 겹친 변경이 여러 건 실패해도 안내는 한 번만 띄운다.
                if (hasFailure) {
                    alert('상태 변경에 실패했습니다. 잠시 후 다시 시도해 주세요.');
                }
            } finally {
                this.isStaffStatusUpdating = false;
            }
        },
        // 참석자 한 명의 상태를 서버에 반영하고 성공 여부를 반환한다.
        async sendStaffStatus(index) {
            // 실패 시 화면을 서버 상태로 되돌리기 위해 직전 값을 기억해 둔다.
            const previousStatus = this.workStaffList[index].staff_status_cd;
            // 전송 시점의 값을 고정한다. 응답을 기다리는 사이 같은 참석자가 다시 바뀔 수 있어,
            // 현재 화면 값을 반영값으로 저장하면 서버에 보낸 값과 어긋난다.
            const staffStatus = this.staffChcek[index];

            try {
                const { data } = await this.attendStatus(index, staffStatus);
                this.workStaffList[index].staff_status_cd = staffStatus;
                // 참여자 전원 완료 여부에 따라 서버에서 게시글 상태가 자동 동기화되므로 화면에도 반영한다.
                if (data && data.status) {
                    this.writeState = data.status;
                    this.workList.status = data.status;
                }
                return true;
            } catch (error) {
                console.log(error);
                // 서버에 반영되지 않았으므로 화면도 되돌린다. 그대로 두면 완료로 보이지만 실제로는 진행중이다.
                this.$set(this.staffChcek, index, previousStatus);
                return false;
            }
        },
        async replyAction(action, staffId, comment) {
            try {
                const { data } = await this.getReplyAction(action, staffId, comment);
                if (action == 'update') {
                    alert('값이 수정되었습니다.');
                    this.commentEdit = false;
                    this.onSearchList();
                } else {
                    alert('값이 삭제되었습니다.');
                    this.onSearchList();
                }
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getReplyAction(action, staffId, comment) {
            return api.put(`/admin/api/centerTask/updateComment/${action}`, {
                centerId: this.centerId,
                centerTaskId: this.centerTaskId,
                centerStaffId: this.centerStaffId,
                centerTaskStaffCommentId: staffId,
                comment,
            });
        },
        // commentEdit(){
        //     this.commentEdit = true
        // },
        editComment(index) {
            this.commentId = index;
            this.commentEdit = !this.commentEdit;
        },
    },
};
</script>
<style lang="scss"></style>
